module.exports = __webpack_public_path__ + "static/media/icon05.109d61bf.svg";